export const NAMESPACE = 'walletTransfer'
